import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'filterParamName' })
export class FilterParamNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(filterParam: string): string {
        switch (filterParam) {
            case 'filterName':
                return this.translateService.instant('Filter name');
            case 'createdBy':
                return this.translateService.instant('Created by');
            case 'onlyMy':
                return this.translateService.instant('Only my inbox');
            case 'hasNoReplyFromTeam':
                return this.translateService.instant('Has no reply from team');
            case 'categoryId':
                return this.translateService.instant('Category');
            case 'folder':
                return this.translateService.instant('Folder');
            case 'status':
                return this.translateService.instant('Status');
            case 'hasAttachments':
                return this.translateService.instant('With Attachments');
            case 'withoutCategory':
                return this.translateService.instant('Uncategorized');
            case 'isAssignedToBot':
                return this.translateService.instant('Is Assigned To Bot');
            case 'isOnlyHelperCategories':
                return this.translateService.instant('Only Helper Categories');
            case 'sentiment':
                return this.translateService.instant('Sentiment');
            case 'sourceSubtype':
                return this.translateService.instant('Source Subtype');
            case 'source':
                return this.translateService.instant('Source');
            case 'tagIds':
                return this.translateService.instant('Tags');
            case 'categoryIds':
                return this.translateService.instant('Categories');
            case 'isAssigned':
                return this.translateService.instant('Assign status');
            case 'fields':
                return this.translateService.instant('Fields');
            case 'assignees':
                return this.translateService.instant('Assigned to');
            case 'assigneeUserGroupIds':
                return this.translateService.instant('Assigned to user groups');
            case 'creationDateFilterType':
                return this.translateService.instant('Created');
            default:
                return '';
        }
    }
}
